<template>
	<div id="copyrightRegistration" class="toRegDetail">
		<div class="main">
			<div class="title">
				版权登记
			</div>
			<div class="tabTit" :style="{height: form.copyrightType != ''?'99px':'68px'}">
				<div class="tit">
					权利权属:
				</div>
				<div class="item_content">
					<RadioGroup class="radio_group monitor_type"
								v-model="form.copyrightType"
								@on-change="powerChange">
            <Radio v-for="(item,index) in powers" class="radio_item" :label="item.value">
              <span class="radio_item_name">{{ item.label }}</span>
            </Radio>
					</RadioGroup>
				</div>
        <div class="red-border-input" v-if="form.copyrightType != ''">
          {{ showPowerText }}
        </div>
			</div>
      <div class="tabTit" :style="{height: form.powerBy != ''?'99px':'68px'}">
        <div class="tit">
          权利取得方式:
        </div>
        <div class="item_content">
          <RadioGroup class="radio_group monitor_type"
                      v-model="form.powerBy"
                      @on-change="powerByChange">
            <Radio v-for="(item,index) in powerBys" class="radio_item" :label="item.value">
              <span class="radio_item_name">{{ item.label }}</span></Radio>
          </RadioGroup>
        </div>
        <div class="red-border-input" v-if="form.powerBy != ''">
          {{ showPowerByText }}
        </div>
      </div>
			<div class="item_wrap">
				<div class="author">
					<div class="item">
						<div class="tit">
							作者:
						</div>
						<div class="content_wrap">
							<div style="display:flex;justify-content:flex-start;align-items: center;">
								<div v-for="(item,index) in autors" :key="index" class="show_autor_Picture">
									<div class="showSc_autor">
										<button class="autors_class">{{item.name}}</button>
										<img @click.stop="deleteAutor(item)" class="showshanchu" src="./images/CombinedShape.png" />
									</div>
								</div>
<!--								<input type="button" value="+添加权利人" class="form_input_btn_select" @click="addAutor('autor')"/>-->
								<div class="btn_wrap">
									<div class="btn" @click="addAutor('autor')">选择作者</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="owner">
					<div class="item">
						<div class="tit">
							著作权人:
						</div>
						<div class="content_wrap">
							<div style="display:flex;justify-content:flex-start;align-items: center;">
								<div v-for="(item,index) in obligees" :key="index" class="show_autor_Picture">
									<div class="showSc_autor">
										<button class="autors_class">{{item.name}}</button>
										<img @click.stop="deleteObligee(item)" class="showshanchu" src="./images/CombinedShape.png" />
									</div>
								</div>
								<div class="btn_wrap">
									<div class="btn" @click="addAutor('obligee')">选择著作权人</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="works_type">
					<div class="item">
						<div class="tit">
							作品类型:
						</div>
						<div class="content_wrap">
              <el-cascader
                  v-model="form.workType"
                  :options="workTypes"
                  placeholder="请选择作品类型"
                  @change="workTypeChange()"
                  popper-append-to-body
              >
                <template slot-scope="{ data }">
                  <!-- tooltip撑开整行，整行悬浮都触发 -->
                  <el-tooltip
                      placement="right"
                      max-width="420"
                      :content="data.text"
                      popper-class="cascader-tooltip"
                  >
                    <div style="width:100%;padding:0 10px;box-sizing:border-box;">
                      {{ data.label }}
                    </div>
                  </el-tooltip>
                </template>
              </el-cascader>
						</div>
					</div>
				</div>
				<div class="works_name">
					<div class="item">
						<div class="tit">
							作品名称:
						</div>
						<div class="content_wrap">
							<el-input placeholder="请输入作品名称" v-model="form.workFullName" @input="workFullnameChange" style="width: 372px" maxlength="60"/>
              <span style="margin-left: 10px">{{workFullNameLength}}</span><span>/</span><span>60</span>
              <div class="showtextDf" style="display: flex;margin-top: 8px">
                <p style="display: flex;"><img src="../vipClip/dci/images/tishi.png" height="18" width="18"/>作品名称请控制在60个字符（30个汉字）以内。</p>
              </div>
						</div>
					</div>
				</div>
				<div class="works_file" :style="{'height':worksList.length > 0 ?'344px':'240px','paddingBottom':worksList.length > 0?'24px':'0px',boxSizing:'border-box'}">
					<div class="item">
						<div class="tit">
							作品文件:
						</div>
						<div class="content_wrap">
							<div class="certList_right">
								<div class="certList_right_top">
									<MyUploadHw :oldShowList="worksList" :fileMultiue="true" textContent="添加作品样本"
                              @click.native="toClick"
												:accept="workType_fileAccept" :pictureTypes="104857600" :documnetTypes="104857600" :otherTypes="104857600" :maxSizes="102400"
												:maxNumber="maxNumber"
												@listentochildevent="showmessagefromchild" />
									<div class="showtextDf">
										<div>温馨提示：</div>
										<!--                                <p>1、同一批的存证文件归属于同一标签，不支持重置；</p>-->
										<p>1、文件数量6个以内；</p>
										<p>2、上传文件大小100M以内；</p>
										<p>3、出现人像、logo等：作品中如涉及人像及其他品牌logo，请提供相关肖像授权书或品牌授权书，如不能提供请去掉作品中所有相关元素。</p>
									</div>
								</div>
								<div class="atlas_group">
									<div v-for="(item,index) in worksList" :key="index" class="show_Picture">
                    <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                      <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                      <p>上传中</p>
                      <div :style="{height:item.uploadProgress + '%'}"
                           class="upload_progress_shadow"></div>
                    </div>
                    <div v-else class="showSc">
											<img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url" />
											<span class="showDelete"><img @click.stop="deleteList(item)" class="showshanchu"
                                                    src="./images/shanchu.png" /></span>
										</div>
                    <Tooltip max-width="300" placement="bottom"
                             :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                      <div style="line-height: 1">{{item.name ?
                          item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                      </div>
                    </Tooltip>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

<!--        <div class="works_file" :style="{'height':productImageUploadFileList.length>0?'auto':'226px',boxSizing:'border-box'}">
          <div class="item">
            <div class="tit">
              作品展示图:
            </div>
            <div class="content_wrap">
              <div class="certList_right">
                <div class="certList_right_top">
                  <MyUploadHw :oldShowList="productImageUploadFileList" :fileMultiue="true"  accept=".jpg,.png,.jpeg" textContent="附件上传"
                              :maxNumber="5" :pictureTypes="26214400" :documnetTypes="26214400" :otherTypes="26214400" :maxSizes="25600"
                              @listentochildevent="showmessagefromchild4" />
                  <div class="showtextDf">
                    <div>温馨提示：</div>
                    <span :style="{'font-size': '14px', 'font-weight': '400', 'color': '#999999', 'line-height': '20px'}">
                        1、作品展示图将显示到证书的“作品展示页”；
                    </span>
                    <p>2、上传的作品展示图须是登记作品文件内的内容，否则此作品登记申请将被驳回；</p>
                    <p>3、支持上传1张图片，图片大小不超过5M，支持png|jpg|jpeg格式；</p>
                    <p>4、请勿上传CMYK色彩模式的图片。</p>
                  </div>
                </div>
                <div class="atlas_group">
                  <div v-for="(item,index) in productImageUploadFileList" :key="index" class="show_Picture">
                    <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                      <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                      <p>上传中</p>
                      <div :style="{height:item.uploadProgress + '%'}"
                           class="upload_progress_shadow"></div>
                    </div>
                    <div v-else class="showSc">
                      <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url" />
                      <span class="showDelete"><img @click.stop="deleteList_zst(item)" class="showshanchu"
                                                    src="./images/shanchu.png" /></span>
                    </div>
                    <Tooltip max-width="300" placement="bottom"
                             :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                      <div style="line-height: 1">{{item.name ?
                          item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>-->


				<div class="works_character">
					<div class="item">
						<div class="tit">
							作品创作性质:
						</div>
						<div class="content_wrap">
              <el-cascader v-model="form.creativeType"
                           :options="creativeTypes"
                           placeholder="请选择作品创作性质">
              >
                <!-- 自定义下拉选项，悬浮弹出说明 -->
                <template slot-scope="{ data }">
                  <!-- tooltip撑开整行，整行悬浮都触发 -->
                  <el-tooltip
                      placement="right"
                      max-width="420"
                      :content="data.text"
                      popper-class="cascader-tooltip"
                  >
                    <div style="width:100%;padding:0 10px;box-sizing:border-box;">
                      {{ data.label }}
                    </div>
                  </el-tooltip>
                </template>
              </el-cascader>
						</div>
					</div>
				</div>
				<div class="works_time">
					<div class="item">
						<div class="tit">
							创作完成时间:
						</div>
						<div class="content_wrap">
							<DatePicker type="date" style="width: 222px;" v-model="form.completeDateEnd" :options="options_create"  :value="form.completeDateEnd" placeholder="选择日期" class="datePickerClass"></DatePicker>
						</div>
					</div>
				</div>
				<div class="works_add">
					<div class="item">
						<div class="tit">
							作品完成地点:
						</div>
						<div class="content_wrap">
							<el-cascader v-model="placeOfCompletion"   :options="citys"></el-cascader>
						</div>
					</div>
				</div>
				<div class="works_state">
					<div class="item">
						<div class="tit">
							作品发表状态:
						</div>
						<div class="content_wrap">
							<div style="display: flex;width: 1170px;">
								<el-cascader v-model="form.publishStatus"
                             :options="publishStatusArr"
                             placeholder="请选择作品发表状态">
                  <template slot-scope="{ data }">
                    <!-- tooltip撑开整行，整行悬浮都触发 -->
                    <el-tooltip
                        placement="right"
                        max-width="420"
                        :content="data.text"
                        popper-class="cascader-tooltip"
                    >
                      <div style="width:100%;padding:0 10px;box-sizing:border-box;">
                        {{ data.label }}
                      </div>
                    </el-tooltip>
                  </template>
                </el-cascader>
								<div v-if="form.publishStatus == '1'" class="publish_status">
									<span class="pulish_status_span">作品首次发表时间</span>
									<DatePicker type="date" v-model="form.publishDate" :options="options_publish"   placeholder="选择日期" class="datePickerClass"></DatePicker>
									<span class="pulish_status_span">作品首次发表地点</span>
									<el-cascader v-model="placeOfPublication"  :props="{ value: 'label' }" :options="citys"></el-cascader>
								</div>
							</div>

						</div>
					</div>

				</div>


        <div class="works_file" v-if="form.publishStatus == '1'" :style="{'height':publishUrlList.length > 0 ?'344px':'240px','paddingBottom':publishUrlList.length > 0?'24px':'0px',boxSizing:'border-box'}">
          <div class="item">
            <div class="tit" style="line-height: 20px;margin-top: 76px;">
              已发表的截图或照片:
            </div>
            <div class="content_wrap">
              <div class="certList_right" style="margin-top: -21px;">
                <div class="certList_right_top">
                  <MyUploadHw :oldShowList="publishUrlList" :fileMultiue="false"  accept=".jpg,.jpeg,.png,.pdf,.doc,.docx" textContent="附件上传"
                              :maxNumber="1"
                              @listentochildevent="showmessagefromchild3" />
                  <div class="showtextDf">
                    <div>温馨提示：</div>
                    <p style="color: red">1、请保证发表截图中的日期与所填首次发表日期一致；</p>
                    <p>2、只支持jpg、jpeg、png、pdf、doc、docx，大小10M以内；</p>
                    <p>3、若有多个发表截图，可拼接成长图，或保存至PDF、Word文档中上传。</p>
                  </div>
                </div>
                <div class="atlas_group">
                  <div v-for="(item,index) in publishUrlList" :key="index" class="show_Picture">
                    <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                      <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                      <p>上传中</p>
                      <div :style="{height:item.uploadProgress + '%'}"
                           class="upload_progress_shadow"></div>
                    </div>
                    <div v-else class="showSc">
                      <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url" />
                      <span class="showDelete"><img @click.stop="deleteList_fj2(item)" class="showshanchu"
                                                    src="./images/shanchu.png" /></span>
                    </div>
                    <Tooltip max-width="300" placement="bottom"
                             :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                      <div style="line-height: 1">{{item.name ?
                          item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="works_file" :style="{'height':autGuarAnnexUploadFileList.length>0?'auto':'226px',boxSizing:'border-box'}">
          <div class="item">
            <div class="tit">
              权利保证书:
            </div>
            <div class="content_wrap">
              <div class="certList_right">
                <div class="certList_right_top">
                  <MyUploadHw :oldShowList="autGuarAnnexUploadFileList" :fileMultiue="true"  accept=".jpg,.png,.pdf,.doc,.docx,.xlsx" textContent="附件上传"
                              :maxNumber="5" :pictureTypes="26214400" :documnetTypes="26214400" :otherTypes="26214400" :maxSizes="25600"
                              @listentochildevent="showmessagefromchild5" />
                  <div class="showtextDf">
                    <div>温馨提示：</div>
                    <span :style="{'font-size': '14px', 'font-weight': '400', 'color': '#999999', 'line-height': '20px'}">
                                  请将作品权利保证书下载后，打印并签字盖章，在此处上传，务必确保《权利保证书》中的作品名称与申请人及签字公章与所填信息一致。
                                </span>
                    <a :href=[guaranteeTemplet[0]] target='_blank' download='' className="creatInfo-span"
                       :style="{'color': '#FFBB19', 'marginLeft': '10px', 'display': 'inline-block', 'text-decoration': 'underline'}">下载模板</a>
                    <p>（必填）</p>
                  </div>
                </div>
                <div class="atlas_group">
                  <div v-for="(item,index) in autGuarAnnexUploadFileList" :key="index" class="show_Picture">
                    <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                      <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                      <p>上传中</p>
                      <div :style="{height:item.uploadProgress + '%'}"
                           class="upload_progress_shadow"></div>
                    </div>
                    <div v-else class="showSc">
                      <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url" />
                      <span class="showDelete"><img @click.stop="deleteList_bzs(item)" class="showshanchu"
                                                    src="./images/shanchu.png" /></span>
                    </div>
                    <Tooltip max-width="300" placement="bottom"
                             :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                      <div style="line-height: 1">{{item.name ?
                          item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>


				<div class="works_file" :style="{'height':enclosureList.length>0?'auto':'226px',boxSizing:'border-box'}">
					<div class="item">
						<div class="tit">
							附件:
						</div>
						<div class="content_wrap">
							<div class="certList_right">
								<div class="certList_right_top">
									<MyUploadHw :oldShowList="enclosureList" :fileMultiue="true"  accept=".jpg,.png,.pdf,.doc,.docx,.xlsx" textContent="附件上传"
                              :maxNumber="5" :pictureTypes="26214400" :documnetTypes="26214400" :otherTypes="26214400" :maxSizes="25600"
												@listentochildevent="showmessagefromchild1" />
									<div class="showtextDf">
										<div>温馨提示：</div>
                    <p>1、请将与作品权属相关的文件（例如签署的协议，合同等）上传在此处；</p>
                    <span :style="{'font-size': '14px', 'font-weight': '400', 'color': '#999999', 'line-height': '20px'}">
                      2、未成年（未满18周岁）权利人提交作品需要同时提供《监护人承诺保证书》及监护人身份证正反面；
                    </span>
                    <a :href=[guaranteeTemplet[1]] target='_blank' download='' className="creatInfo-span"
                       :style="{'color': '#FFBB19', 'marginLeft': '10px', 'display': 'inline-block', 'text-decoration': 'underline'}">下载模板</a>
                    <p>3、最多只能上传5个文档，文档总大小25M以内，只支持jpg、png、pdf、doc、docx、xlsx格式；</p>
                    <p>（此处为附件上传，请不要将作品文件传在此处）</p>
									</div>
								</div>
								<div class="atlas_group">
									<div v-for="(item,index) in enclosureList" :key="index" class="show_Picture">
                    <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                      <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                      <p>上传中</p>
                      <div :style="{height:item.uploadProgress + '%'}"
                           class="upload_progress_shadow"></div>
                    </div>
										<div v-else class="showSc">
											<img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url" />
											<span class="showDelete"><img @click.stop="deleteList_fj(item)" class="showshanchu"
                                                    src="./images/shanchu.png" /></span>
										</div>
                    <Tooltip max-width="300" placement="bottom"
                             :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                      <div style="line-height: 1">{{item.name ?
                          item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                      </div>
                    </Tooltip>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="works_declare" v-if="form.copyrightType=='2' || form.copyrightType=='4' || form.copyrightType=='5'">
					<div class="item">
						<div class="tit">
							创作声明:
						</div>
						<div class="content_wrap">
							<div>
								<div style="display: flex;">
									<MyUploadHw :oldShowList="statementList" :fileMultiue="false" accept=".jpg,.png"
												styleType="btn"  @listentochildevent="showmessagefromchild2" />
									<span v-if="declare_upload_success" style="margin-left: 20px;margin-top:10px;">{{declare_file_name}}</span>
									<a :href="[declare_down_urls[form.copyrightType]]" target='_blank' download='合作声明.docx' class="creatInfo-span">下载模板</a>
									<span style="margin-top:10px;">｜</span>
									<u class="declare_sample" @click="showDeclareSample">查看样例</u>
								</div>
								<div className="tipUpload" >
								</div>
                <div class="showtextDf" style="color: #999999">
                  <p style="margin-top:10px;">温馨提示：</p>
                  <p style="margin-top: 10px;">1、请按照模板样例内容仔细填写，注意个人需手写签字，企业需加盖公章，填写完成后拍照上传。格式jpg,png，大小10M以内；</p>
                  <p>2、请保证声明中的内容与以上所填信息保持一至。</p>
                  <p>3、重新上传，会覆盖原来的文件；</p>
                </div>
							</div>
						</div>
					</div>
				</div>
				<div class="works_possess" style="height: 255px">
					<div class="item" style="height: 255px">
						<div class="tit">
							权利拥有情况:
						</div>
						<div class="content_wrap">
							<div><input type="checkbox" v-model="isSlectedAll"  :disabled="isAllDisabled" style="margin-right: 10px;"/>
                <span>全选</span></div>
							<div class="owner_checkbox">
								<p v-for="(item,index) in Ownership" :key="index">
									<input type="checkbox" v-model="item.checked" :disabled="isRightDisabled(item)"/>
									<span>{{item.label}}</span>
								</p>
							</div>
              <div class="showtextDf" style="color: #999999">
                <div style="margin-top: 10px;margin-bottom: 10px">温馨提示：</div>
                <p>1、请按照合同约定内容勾选；</p>
                <p>2、个人作品、法人作品、合作作品需勾选所有权利；</p>
                <p>3、权利取得方式为继承时不能勾选发表权、署名权、修改权、保护作品完整权。</p>
              </div>
						</div>
					</div>
<!--          <div style="margin-left: 199px;background-color: #fff;">
            <p style="margin-top:10px;">温馨提示：</p>
            <p style="margin-top:10px;">请按照合同约定内容勾选；</p>
            <p style="margin-top:10px;">个人作品、法人作品、合作作品需勾选所有权利；</p>
            <p style="margin-top:10px;">权利取得方式为继承时不能勾选发表权、署名权、修改权、保护作品完整权。</p>
          </div>-->


				</div>
				<div class="works_intention">
					<div class="item">
						<div class="tit">
							创作意图:
						</div>
						<div class="content_wrap">
							<el-input type="textarea" :rows="4" placeholder="请输入内容"  maxlength="500" style="width: 760px;"
									  show-word-limit   v-model="form.createIntention"></el-input>
							<span>(必填)</span>
						</div>
					</div>
				</div>
				<div class="works_create">
					<div class="item">
						<div class="tit">
							作品独创性:
						</div>
						<div class="content_wrap">
							<el-input type="textarea" :rows="4" placeholder="请输入内容"  maxlength="500" style="width: 760px"
									  show-word-limit v-model="form.creationOriginality"></el-input>
							<span>(选填)</span>
						</div>
					</div>
				</div>
				<div class="works_create" v-if="!$route.query.id">
					<div class="item">
						<div class="tit">
							支付方式：
						</div>
						<div class="cw_ul_type" style="margin-top: -24px;">
							<component :is="PayWay" @onselected="handlePayWaySelect" type="0202" :copyrightCode='copyrightCode' style="margin-top: 20px;"></component>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="sub">
      <div style="padding-bottom: 15px;text-align: center;">
        <input id="protocalCheck" type="checkbox"/><span style="margin-left: 5px;">我已阅读并同意<a @click="lawLink(2)" >《申请版权预登记及作品登记须知》</a></span>
      </div>

			<div class="btn" @click="addcert" :class="{ 'disabled': isDisabled }">
				提交
			</div>
		</div>

		<CertAutorVerify v-if="isAddAutor" :obligeeArr="chooseObligeeArr" :is-radio="powerIsRadio"  :my-title="verifyTitle" @fatherModal="chooseAutor"/>
		<DeclareSample v-show="isShowDeclare" :declare-type="declareSrc" @fatherModal = "isShowDeclare=false"/>
	</div>
</template>

<script>
	import {cityCode} from "../../libs/cityCode";
	import {_getByPage} from "@/api/obligee.js";
	// import {_save,_getDetail,_resubmit} from "../../../api/register";
	import {_save,_getDetail,_resubmit,_getWorksTypeCopyright}  from "../../api/register";
	import Cookies from "js-cookie";
	import MyUploadHw from '@/views/main-components/my-upload-hw';
	import Timeline from '@/views/main-components/horizontal-timeline';
	import CertAutorVerify from "./cert-autor-verify";
	import '@/plugins/element.js';
	import DeclareSample from "./declareSample";
	import {_saveData,_getObligeeParams} from "./cpRegistData";
	import util from '../../libs/util'
	import PayWay from '@/views/main-components/pay-way';

	const reImg = /^(bmp|png|jpg|gif|jpeg)$/;
	const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
	const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
	const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;


	export default {
		name: "copyrightLogin",
		components: {
			MyUploadHw,
			Timeline,CertAutorVerify,DeclareSample,PayWay
		},
		data() {
			return {
        cachePersonRightCheck: [],
				isPreRechargeFlag:null,
				copyrightCode:null,
				userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
				flagId:'', //存证ID
				PayWay:'',
				payWay: '',
				test:["中国","北京市","东城区"],
				// test:["0","110000","110101"],
				originObligeeArr:[],//著作人的数据
				chooseObligeeArr:[], //点击弹窗，里面的内容
				isAddAutor:false, //是否添加作者/著作人
				citys:[], //城市
				getObligeeParams:[], //获取作者/著作人的参数
				//作品类型
        // workTypes:[],//从接口获取
        productImageUploadFileList: [],//作品展示图
        autGuarAnnexUploadFileList: [],//权利保证书
				/*workTypes:[{label:"设计手稿",value:"1"},
          {label:"设计图",value:"2"},
          {label:"产品摄影",value:"3"},
          {label:"产品视频",value:"4"},
          {label:"设计创意稿",value:"5"}],*/

        workTypes:[{label:"文字作品",type:"text",value:"text",text:"以文字表达的小说、诗词、散文、论文、文案等。"},
          {label:"摄影作品",type:"picture",value:"picture",text:"借助设备记录形象的艺术照片、图片。"},
          {label:"工程设计图",type:"picture",value:"projectimage",text:"建筑、路桥、机械等工程施工所用设计图纸。"},
          {label:"产品设计图",type:"picture",value:"productdesign",text:"家电、器械、工业品等产品研发制作图纸。"},
          {label:"地图",type:"picture",value:"map",text:"标注地理方位、地界、地貌的各类测绘图样。"},
          {label:"示意图",type:"picture",value:"view",text:"简易描绘原理、流程、结构，辅助理解的简图。"},
          {label:"建筑作品",type:"picture",value:"build",text:"有审美意义的建筑物或构筑物设计成果。"},
          {label:"模型作品",type:"picture",value:"model",text:"依照比例制作，用于展示参考的立体造型。"},
          {label:"美术作品",type:"picture",value:"art",text:"绘画、书法、雕塑等有审美意义的造型艺术作品。"},
          {label:"舞蹈作品",type:"video",value:"dance",text:"用连续动作、姿势、表情表达情感的作品。"},
          {label:"杂技艺术作品",type:"video",value:"acrobatics",text:"杂技、魔术、马戏等靠形体动作和技巧表现的作品。"},
          {label:"录音制品",type:"audio",value:"soundRecording",text:"任何对表演的声音和其他声音的录制品。"},
          {label:"录像制品",type:"video",value:"videotape",text:"电影作品和以类似摄制电影的方法创作的作品以外的任何有伴音或者无伴音的连续相关形象、图像的录制品。"},
          {label:"电影作品",type:"video",value:"movie",text:"院线公映的完整影片。"},
          {label:"视听（类似摄制电影方法创作的作品）",type:"video",value:"media",text:"短视频、网剧、微电影等影像成片。"},
          {label:"音乐作品",type:"audio",value:"music",text:"歌曲、交响乐等可演唱或演奏的带词 / 不带词作品。"},
          {label:"口述作品",type:"audio",value:"talk",text:"即兴演说、授课、辩论等口头表达的作品。"},
          {label:"戏剧作品",type:"audio",value:"drama",text:"话剧、歌剧、戏曲等供舞台演出的剧本。"},
          {label:"曲艺作品",type:"audio",value:"song",text:"相声、快书、评书等以说唱为主的表演作品。"},
          {label:"视听（电影作品）",type:"video",value:"media",text:"电影、网剧、短视频等由系列画面伴音组成的影像作品。"}],
				//作品性质
				creativeTypes:[
					{label:"原创",value:"1",text:"独立构思创作，全新产出原创内容。"},
          {label:"改编",value:"2",text:"基于原有作品，调整形式、内容形成新作。"},
          { label:"翻译",value:"3",text:"将作品文字转换为其他语种文本。"},
					{ label:"汇编" ,value:"4",text:"遴选多篇独立作品，统筹编排形成合集。"},
          {label:"注释",value:"5",text:"对原有作品内容进行注解、释义说明。"},
          { label:"整理",value:"6",text:"梳理零散素材，规整完善为完整作品。"},
          { label:"其他",value:"7",text:"不属于上述类型的创作形式。"}
				],
				publishStatusArr:[ {label:"未发表",value:"0",text:"作品创作完成后，从未以任何形式公开，一直没对外发布，没公开传播过。"},
          {label:"已发表",value:"1",text:"著作权人自行或授权他人，将作品首次公之于众，包括出版、上网、展出、演出、发售等任何方式对外公开过。"}],

				isShowDeclare:false, //显示合作声明图片
				declareSrc:"3", //查看声明图片地址
				declare_down_urls:["","","https://file.bqj.cn/file/acc22d35025a28b80d9bc578bf108b58.docx",
					"",
					"https://pub-bluefile.bqj.cn/urkunde/3211eb99fb9c16907cdec30886a2aad0.docx",
					"https://pub-bluefile.bqj.cn/urkunde/bbd17aee92606185f38f2a6520b99e06.docx"
				],//声明 下载地址
        guaranteeTemplet: ["https://pub-bluefile.bqj.cn/urkunde/76a366cf16a21dc2a9e4f9be03237866.docx",//权利保证书
                            "https://pub-bluefile.bqj.cn/urkunde/09a46b467450e1c6d4fe82b71ad72cf9.docx"],//监护人承诺保证书
				declare_file_names:["","","合作作品创作声明","","职务作品创作声明", "委托作品创作声明"],
				declare_upload_success:false,
				declare_file_name:"",
        showPowerText:"",
        showPowerByText:"创作者创作完成作品，直接首次取得著作权。",
				// 1.个人作品 2.合作作品 3.法人作品 4.职务作品 5.委托作品
				powers:[{label:"个人作品",checked:true,value:"1",text:"由单个自然人独立创作，自己承担责任，著作权归个人。"},
          {label:"法人作品",checked:false,value:"3",text:"由法人 / 组织主持，体现法人意志，由法人承担责任，法人视为作者。"},
					{label:"合作作品",checked:false,value:"2",text:"两人以上共同创作，都参与实质性创作，著作权共同享有。"},
          {label:"职务作品",checked:false,value:"4",text:"员工为完成单位工作任务所创作，一般著作权归作者，单位有优先使用权。"},
					{label:"委托作品",checked:false,value:"5",text:"一方委托另一方创作，著作权按合同约定；无约定时归受托人。"}],

        powerBys: [{label: "原始", checked: true, value: "1", text:"创作者创作完成作品，直接首次取得著作权。"},
          {label: "继承", checked: false, value: "2", text:"作者离世后，合法继承人依法获取著作财产权。"},
          {label: "承受", checked: false, value: "3", text:"法人主体变动终止，由承接权责的主体取得著作权。"}],
				////权力权属
				Ownership:[
					{ label: '发表权', value: '1',checked:false },
					{ label: '署名权', value: '2' ,checked:false},
					{ label: '修改权', value: '3' ,checked:false},
					{ label: '保护作品完整权', value: '4' ,checked:false},
					{ label: '复制权', value: '5' ,checked:false},
					{ label: '发行权', value: '6' ,checked:false},
					{ label: '出租权', value: '7' ,checked:false},
					{ label: '展览权', value: '8' ,checked:false},
					{ label: '表演权', value: '9' ,checked:false},
					{ label: '放映权', value: '10' ,checked:false},
					{ label: '广播权', value: '11' ,checked:false},
					{ label: '信息网络传播权', value: '12' ,checked:false},
					{ label: '摄制权', value: '13' ,checked:false},
					{ label: '改编权', value: '14' ,checked:false},
					{ label: '翻译权', value: '15',checked:false },
					{ label: '汇编权', value: '16',checked:false },
					{ label: '其他', value: '17',checked:false },
				],//权益拥有情况
				declare_fileAccept:".png,.jpg",
				declare_fileFormat:[".png",".jpg"],
				workType_fileAccept:".pdf,.doc,.docx,.txt,.bmp,.png,.jpg,.gif,.jpeg,.wav,.mp3,.wma,.acc,.acc,.mp4",
				autors:[], //作者
				obligees:[],//权人

				worksList:[],//作品
				enclosureList:[],//附件
				statementList:[],//创作声明
        publishUrlList:[],//已发表的截图或照片
				powerIsRadio:"false",
				maxNumber:6,
				form:{powerBy : "1"},
				copyrightDetailsId:"",
				isReset:false ,
				keepAliveData:{},
				oldCopyrightType:"1",
				isDisabled:false,
        workFullNameLength: 0,
				rules:{
					name:[
						{required: true, message: '请输入活动名称', trigger: 'blur'}
					], //音乐名称
					files:[ {required: true, message: '请选择文件', trigger: 'blur'}], //音乐文件
					autor:[ {required: true, message: '请添加权利人', trigger: 'blur'}], //作者
					obligee:[ {required: true, message: '请添加权利人', trigger: 'blur'}],//权人
				},
				music:require('@/assets/music_icon.png'),
				text:require('@/assets/text_icon.png'),
				video:require('@/assets/video_icon.png'),
				other:require('@/assets/file_icon.png'),
        options_create: {
          disabledDate(date) {
            //如果可以包含当天，那么 就不用减去8640000，如果不能包含当天，则需要减去
            return date && date.valueOf() > Date.now();
          }
        },
        options_publish: {
          disabledDate: (date) => {
            // console.log(this.form.completeDateEnd);
            let d = new Date(this.form.completeDateEnd);
            // console.log("d ====>>>> ",d);
            return date && !(date.valueOf() <= Date.now() && date.valueOf() >= d);
          }
        },
        placeOfCompletion: [], //作品完成地点
        placeOfPublication: [], //作品发表地点
        otherFileFormat:"",
        reSubmitDisabled: true,
      }
    },
		watch:{
			"$store.state.app.showPayWay":function(){
				if(this.$store.state.app.showPayWay){
					this.userInfo = JSON.parse(Cookies.get("userInfo")),
					this.flagId = '',
					this.PayWay = 'PayWay'
				}
			}
		},
		created() {
      this.copyrightCode = this.$route.query.code;
			console.log(this.$route.query);
			console.log("created :::::::::: ",_saveData);
			this.getObligeeParams=_getObligeeParams;

			let _this = this ;
			let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):"";

			if (this.$route.query.id && this.$route.query.id != '') {
				this.copyrightDetailsId = this.$route.query.id;
				this.flagId = this.$route.query.id;
				this.isReset = true ;
				this.getDetail();
			}else
			{
				// this.form = {..._saveData};
			}

			if(userInfo)
			{
				this.getObligeeParams.registerId = userInfo.id;
				this.getByPage(this.getObligeeParams);
				// this.getWorksTypeCopyright();

        if(userInfo.accountType == 'person'){
          this.form.copyrightType = "1"
        }else if(userInfo.accountType == 'enterprise'){
          this.form.copyrightType = "3"
        }
			}
			this.isLogin = Cookies.get("userInfo")? true : false;
			this.$store.state.app.showPayWay =Cookies.get("userInfo") && Cookies.get("userInfo") != ''? true : false
			this.PayWay = this.$store.state.app.showPayWay? 'PayWay':''
		},
		mounted(){
			this.citys = cityCode ;
      // 初始化执行一次，渲染单选、填充说明文字
      this.$nextTick(()=>{
        if(this.form.copyrightType){
          this.powerChange(this.form.copyrightType)
        }
        if(this.form.powerBy){
          this.powerByChange(this.form.powerBy)
        }
      })
		},

		computed:{
      forbidRightIds(){
        return ['1','2','3','4']
      },
      isAllDisabled(){
        return this.form.powerBy === '2'
      },
      isRightDisabled(){
        return (item) => {
          return this.form.powerBy === '2' && this.forbidRightIds.includes(item.value)
        }
      },
			isSlectedAll:{
				get(){
					let isAll = true ;
					this.Ownership.forEach(item=>{
						if(item.checked == false)
						{
							isAll = false ;
							return ;
						}
					})
					return isAll ;
				},
				set(value){
					this.selectAll(value);
				}
			}
		},
		methods: {
      toClick(){
        if(this.isReset && this.reSubmitDisabled){
          toastNewline('请谨慎修改作品文件！\n' +
              '作品文件任何变动均视为新订单，出证日期将重新计算！')
          this.reSubmitDisabled = false
        }
      },
      lawLink(id){
        let routeData = this.$router.resolve({ name: 'instrument', params: { id: id } });
        window.open(routeData.href, '_blank');
      },
			handlePayWaySelect(e) {
				console.log(e);
				this.payWay = e;
				if(e == null){
					this.isPreRechargeFlag = 0
				}else{
					if(e.activityName == "预存权益支付"){
						this.isPreRechargeFlag = 1
					}else{
						this.isPreRechargeFlag = 0
					}
				}
			},
			/*********获取作者/著作人***************/
			async getByPage(parms){
				// //debugger;
				let _this = this ;
				let res = await _getByPage(parms);
        await _this.sleep(1000);
				if(res.code == "200"){
					let data = res.result.records;
					data.forEach(item=>{
						item.checked = false ;
					});
					_this.originObligeeArr = data ;

					if(this.isReset == true){
						//作者处理 originObligeeArr
						_this.autors = [];
						_this.form.authorIds.forEach(value=>{
							console.log(value) ;
							for(let i=0;i<_this.originObligeeArr.length;i++){
								console.log(_this.originObligeeArr[i]);
								if(_this.originObligeeArr[i].id == value)
									_this.autors.push(_this.originObligeeArr[i]);
							}
						});
						//著作人处理
						// //debugger ;
						_this.obligees = [];
						_this.form.powerIds.forEach(value=>{
							for(let i=0;i<_this.originObligeeArr.length;i++){
								if(_this.originObligeeArr[i].id == value)
									_this.obligees.push(_this.originObligeeArr[i]);
							}
						});
					}
				}

			},
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      //作品类型
      async getWorksTypeCopyright() {
        let _this = this;
        _getWorksTypeCopyright().then((res) => {
          if (res.code == '200') {
            _this.workTypes = res.result
            /*_this.setState({
              _this.workTypes: res.result
            })*/
            /*for(let i in res.data.list){
              if(res.data.list[i].pCode == "other"){
                let sx = res.data.list[i].fileFormat.split('|');
                let newF = [];
                sx.map((item) => {
                  newF.push('.' + item)
                })
                _this.setState({
                  otherFileFormat: newF.join(',')
                })
                console.log(_this.state.otherFileFormat)
              }
            }*/
          }
        }).catch(function (error) {
          console.log(error);
        });
      },
			/************获取登记详情***********/
			getDetail() {
				console.log("***********获取登记详情***********")
				let _this = this ;
				let data = {orderSeqNo: this.copyrightDetailsId};
				_getDetail(data).then(res => {
					if (res.code == 200) {
						_this.form = _saveData ;
						Object.assign(_this.form,res.result);
						_this.form = res.result;
						//特殊处理，数据库返回来得字段，与传值字段不一样
						_this.form.workType = _this.form.workTypeDesc ;//文字，看一会是不是需要转化成数字

						_this.form. workUrl = _this.form.worksAttachments ;
						_this.form.completeDateEnd = _this.form.completeDate ;
						//权力权属，获取到得是文字
						_this.form.copyrightType = _this.getValueByLabel(_this.form.copyrightType,_this.powers);
						_this.oldCopyrightType = _this.form.copyrightType ;
						//作品类型 处理
						_this.form.workType = _this.getValueByLabel(_this.form.workTypeDesc,_this.workTypes);

            _this.publishUrlList = []
            if(_this.form.publishUrl != '' && _this.form.publishUrl != null) {
              _this.form.publishUrl.split(',').forEach((value, index) => {
                let obj = {};
                obj.attachmentUrl = value;
                obj.url = util.thumbnail(value);
                _this.publishUrlList.push(obj);
              });
            }

						//作品文件处理
						_this.worksList = [];
						_this.form.workUrl.forEach((value,index)=>{
							let obj = {};
							obj.attachmentUrl = value ;
							obj.url = util.thumbnail(value) ;
							obj.name = "作品"+ (index+1) +"." + value.split(".")[1];
							_this.worksList.push(obj);
						});
						//作品创作性质 处理
						_this.form.creativeType = _this.getValueByLabel(_this.form.creativeType,_this.creativeTypes);
						//时间得处理

						//完成 地点得处理
						let arr = [];
						//debugger ;
						arr.push(_this.form.completeCountry);
						arr.push(_this.form.completeProvince);
						arr.push(_this.form.completeCity);
						_this.placeOfCompletion = arr;

            //作品展示图处理
            if (_this.form.productImageAttachments != "" || _this.form.productImageAttachments != null) {
              _this.productImageUploadFileList = [];
              let productImageAttachments = (_this.form.productImageAttachments).split(',');
              if (productImageAttachments[0] != "") {
                productImageAttachments.forEach((value, index) => {
                  let obj = {};
                  obj.attachmentUrl = value;
                  obj.url = util.thumbnail(value);
                  let layout = value.substring(value.lastIndexOf('.') + 1)
                  if(reImg.test(layout)){
                    obj.url = util.thumbnail(obj.url);
                  }else if(reMusic.test(layout)){
                    obj.url = _this.music;
                  }else if(reText.test(layout)){
                    obj.url = _this.text;
                  }else if(reVideo.test(layout)){
                    obj.url = _this.video;
                  }else{
                    obj.url = _this.other;
                  }
                  obj.name = "附件" + (index + 1) + "." + layout;

                  _this.productImageUploadFileList.push(obj);
                });
              } else {
                _this.form.productImageAttachments = "";
              }
            }

            //权利保证书
            if (_this.form.autGuarAnnexAttachments != "" || _this.form.autGuarAnnexAttachments != null) {
              _this.autGuarAnnexUploadFileList = [];
              let autGuarAnnexAttachments = (_this.form.autGuarAnnexAttachments).split(',');
              if (autGuarAnnexAttachments[0] != "") {
                autGuarAnnexAttachments.forEach((value, index) => {
                  let obj = {};
                  obj.attachmentUrl = value;
                  obj.url = util.thumbnail(value);
                  let layout = value.substring(value.lastIndexOf('.') + 1)
                  if(reImg.test(layout)){
                    obj.url = util.thumbnail(obj.url);
                  }else if(reMusic.test(layout)){
                    obj.url = _this.music;
                  }else if(reText.test(layout)){
                    obj.url = _this.text;
                  }else if(reVideo.test(layout)){
                    obj.url = _this.video;
                  }else{
                    obj.url = _this.other;
                  }
                  obj.name = "附件" + (index + 1) + "." + layout;

                  _this.autGuarAnnexUploadFileList.push(obj);
                });
              } else {
                _this.form.autGuarAnnexAttachments = "";
              }
            }

						//附件处理
						if(_this.form.otherAttachments != "" || _this.form.otherAttachments != null){
							_this.enclosureList = [];
							if(_this.form.otherAttachments[0] != ""){
								_this.form.otherAttachments.forEach((value,index)=>{
									let obj = {};
									obj.attachmentUrl = value;
									obj.url = util.thumbnail(value) ;
									obj.name = "附件"+ (index+1) +"." + value.substr(value.length-4,4);
									_this.enclosureList.push(obj);
								});
							}else{
								_this.form.otherAttachments = "";
							}
						}

						//debugger ;
						_this.form.publishStatus = _this.getValueByLabel(_this.form.publishStatus,_this.publishStatusArr);

						if(_this.form.publishStatus == "1")
						{
							//发表地点的 处理
							if(_this.form.publishCity !="" || _this.form.publishCity != null){
								let parr = [];
								parr.push(_this.form.publishCountry);
								parr.push(_this.form.publishProvince);
								parr.push(_this.form.publishCity);
								_this.placeOfPublication = parr ;
							}
						}

						//创作声明
						if(_this.form.copyrightType=="2" || _this.form.copyrightType=="4" || _this.form.copyrightType=="5"){

							_this.statementList[0] = {
								attachmentUrl:_this.form.workInstruction ,
								url:_this.form.workInstruction,
								name:"创作声明"
							};
							this.declare_file_name = _this.declare_file_names[Number(_this.form.copyrightType)] + _this.form.workInstruction.substr(_this.form.workInstruction.length-4,4);
							_this.declare_upload_success=true; //显示创作声明的文本标签是否显示
						}
						//权力权益
						_this.form.powerScope.split(",").forEach(value=>{
							_this.Ownership[value-1].checked=true ;
						})

						//创作意图
						_this.$set(_this.form, "createIntention", _this.form.creationIntentions)
            _this.form.workFullName = _this.getStrByLength(_this.form.workFullName, 60);
            _this.workFullNameLength = _this.getLength(_this.form.workFullName);


					}
				}, (err) => {
					toast('网络断开连接，请重试')
				})
			},

			//通过名称获取value，用于权力权属，作品类型，作品性质，发表状态
			getValueByLabel(name,originArr){
				let value = "";
				originArr.forEach(item=>{
					if(item.label == name)
						value = item.value ;
				});
				return value ;
			},
      powerByChange(selectValue){
        const textMap = {
          "1": "创作者创作完成作品，直接首次取得著作权。",
          "2": "作者离世后，合法继承人依法获取著作财产权。",
          "3": "法人主体变动终止，由承接权责的主体取得著作权。"
        };
        this.showPowerByText = textMap[selectValue] || "";

        /*const targetItem = this.powerBys.find(item => item.value === selectValue)
        if (targetItem) {
          this.showPowerByText = targetItem.text
        } else {
          this.showPowerByText = ""
        }*/
        const forbidIds = ['1','2','3','4'];
        const personRights = this.Ownership.filter(i=>forbidIds.includes(i.value));
        if(selectValue === '2'){
          // 切换继承：精准缓存4项人身权勾选状态
          this.cachePersonRightCheck = personRights.map(i=>i.checked);
          personRights.forEach(item=>{
            item.checked = false;
          })
        }else{
          // 切换非继承：按数组一一对应恢复，避免索引错位
          personRights.forEach((item, idx)=>{
            item.checked = (this.cachePersonRightCheck[idx] !== undefined) ? this.cachePersonRightCheck[idx] : false;
          })
        }
      },
			powerChange(selectValue){
				let that = this;
				//如果权力权益发生变化，那么，创作声明都需要重新上传文件
				let currValue = this.form.copyrightType ;
				this.declare_file_name = "";
				this.declare_upload_success = false ;
				console.log(this.keepAliveData);
				// if(this.keepAliveData[this.oldCopyrightType] == null){
					console.log('进1',selectValue)
        const forbidIds = ['1','2','3','4'];
        this.form.powerBy = "1";
        this.showPowerByText = "创作者创作完成作品，直接首次取得著作权。";
        this.cachePersonRightCheck = [];

        //全选权利拥有情况
        if(selectValue == 1 || selectValue == 2 || selectValue == 3){
          this.selectAll(true)
          this.cachePersonRightCheck = this.Ownership.filter(i=>forbidIds.includes(i.value)).map(i=>i.checked);
        }else{
          this.selectAll(false)
          this.cachePersonRightCheck = [];
        }
					var obj ={};
					obj.form = {...this.form} ;
					obj.autors = [...this.autors ];
					obj.obligees = [...this.obligees ];
					obj.worksList = [...this.worksList];//作品
					obj.enclosureList=[...this.enclosureList];//附件
					obj.statementList = [...this.statementList ];//创作声明
					this.keepAliveData[this.oldCopyrightType] = {...obj};
				// }
				//把当前的权利归属字段赋给记录字段
				this.oldCopyrightType = this.form.copyrightType ;

				if(this.keepAliveData[this.form.copyrightType] != null){
					console.log('进2')
					let obj = {...this.keepAliveData[this.form.copyrightType]};
					console.log(obj);
					this.form = obj.form;
					this.autors = obj.autors;
					this.obligees = obj.obligees;
					// this.worksList = [];
					// that.$nextTick(function(){
						that.worksList = obj.worksList;
					// });

					// this.worksList = obj.worksList;
					this.enclosureList = obj.enclosureList ;
					this.statementList = obj.statementList;
				}
				else{
					console.log('进3')
					this.form = _saveData ;
					this.autors = [];
					this.obligees = [];
					// this.worksList = [];
					this.statementList = [];
					this.enclosureList = [];
				}
				//这里需要把当前的权利归属字段重新赋值给form,因为这里form进行了重新赋值，而_saveData里面，权利归属的初始值是1，是个人
				this.form.copyrightType = currValue ;

        const targetItem = this.powers.find(item => item.value === selectValue)
        if (targetItem) {
          // 把当前项的text赋值给展示变量
          this.showPowerText = targetItem.text
        } else {
          this.showPowerText = ""
        }
			},
			//作品类型发生改变
			workTypeChange(){
        let _this = this;
        let bigWorkType = _this.getTypeByValue(_this.form.workType,_this.workTypes);
				if(bigWorkType == 'text'){
          _this.workType_fileAccept = ".pdf,.doc,.docx,.txt";
					this.copyrightCode = 2002;
        }else if(bigWorkType == 'picture'){
					this.workType_fileAccept = ".png,.jpg,.jpeg";
					this.copyrightCode = 2001;
				}else if(bigWorkType == 'audio'){
          this.workType_fileAccept = ".wav,.mp3,.wma,.acc,.mp4";
          this.copyrightCode = 2003;
        }else if(bigWorkType == 'video'){
          _this.workType_fileAccept = ".flv,.mp4";
          this.copyrightCode = 2003;
        }

        let fileAcceptList = _this.workType_fileAccept.split(',');
        for(let i = 0;i < this.worksList.length;i++) {
          let isHave = 0;
          let fileName = this.worksList[i].name;
          let index= fileName.lastIndexOf(".");
          //获取后缀
          let ext = '.' + fileName.substr(index+1);
          for (let fileAccept in fileAcceptList) {
            if(ext == fileAcceptList[fileAccept]){
              isHave = 1;
              break;
            }
          }
          if(isHave == 0) {//不包含则删除该作品文件
            this.worksList.splice(i, 1);
            i--;
          }
        }
			},
      getTypeByValue(value,originArr){
        let type = "";
        originArr.forEach(item=>{
          if(item.value == value)
            type = item.type ;
        });

        return type ;
      },

      workFullnameChange(){
        let _this = this;
        let wfn = _this.form.workFullName;
        wfn = _this.getStrByLength(wfn, 60);
        let len = _this.getLength(wfn);

        this.form.workFullName = wfn;
        this.workFullNameLength = len;
      },


      getLength(str){
        let len = str.length;
        let reLen = 0;
        for(let i=0;i < len;i++){
          if(str.charCodeAt(i) < 27 || str.charCodeAt(i) > 126){
            reLen += 2;
          }else{
            reLen++;
          }
        }
        return reLen;
      },

      getStrByLength(str, length){
        let _this = this;
        let resultStr = '';
        let len = str.length;
        let reLen = 0;
        for(let i=0;i < len;i++){
          if(str.charCodeAt(i) < 27 || str.charCodeAt(i) > 126){
            reLen += 2;
          }else{
            reLen++;
          }
        }
        while(reLen > length){
          str = _this.getStrByLength(str.slice(0, -1),  length)
          reLen = _this.getLength(str);
        }
        resultStr = str
        return resultStr;
      },

      //添加作者，弹出添加作者窗口
			addAutor(flag){
				this.autorOrObligee = flag ;
				this.verifyTitle = this.autorOrObligee=="autor"?"添加作者":"添加著作人";
				//个人作品，作者和著作人是一个人，选择一个  obligeeType person：“个人” enterprise “企业”
				this.powerIsRadio = "false"; //false 复选，true：单选
				let data =[] ;
				this.chooseObligeeArr = [];
				// debugger ;
				console.log("选择作者，当前类型 ：： ",this.form.copyrightType);
				if(this.form.copyrightType == "1"){
					data= this.originObligeeArr.filter(item=>{
						return item.obligeeType == "person";
					});
					if(data.length ==0)
					{
						toast("您还没有添加个人权利人，请先添加权利人再来登记，或稍后重试");
						return false ;
					}
					this.powerIsRadio = "true";
				}
				// 法人作品，作者和著作人只能是企业，只能选一个
				else if(this.form.copyrightType == "3"){
					this.powerIsRadio = "true";
					data= this.originObligeeArr.filter(item=>{
						return item.obligeeType == "enterprise";
					});

					if(data.length ==0){
						toast("您还没有添加企业，请先添加企业再来登记，或稍后重试");
						return false ;
					}
				}
				// 职务，作者可以多个，著作权人只能是一个
				else if(this.form.copyrightType == "4" && this.autorOrObligee!="autor"){
					this.powerIsRadio = "true";
					data = this.originObligeeArr ;
				}else{
					data = this.originObligeeArr;
				}

				this.chooseObligeeArr = [...data.map(aInfo => {
					return Object.assign({}, aInfo)
				})]

				this.isAddAutor = true ;
			},
			//关闭 添加作者窗口，获取选中得作者
			chooseAutor(data){
				console.log(data);
				this.isAddAutor = false ;
				//个人作品，作者和著作人是一个人，选择一个，两个都变
				if(this.form.copyrightType == "1"){
					this.autors = [...data] ;
					this.obligees =  [...data] ;
				}
				//法人作品，作者和著作人 只能选一个
				else if(this.form.copyrightType == "3"){
					if(this.autorOrObligee == "autor")
						this.autors =  [...data] ;
					else
						this.obligees = [...data] ;
				}
				// 职务，著作权人只能是一个
				else if(this.form.copyrightType == "4" && this.autorOrObligee != "autor"){
					this.obligees = [...data] ;
				}else{
					if(this.autorOrObligee==="autor"){
						let arr=[...this.autors,...data] ;
						this.autors = arr.reduce((acc, cur) => {
							!acc.some(v => v.name === cur.name) && acc.push(cur);
							return acc;
						}, []);
					}else if(this.autorOrObligee ==="obligee"){
						let arr=[...this.obligees,...data] ;
						this.obligees = arr.reduce((acc, cur) => {
							!acc.some(v => v.name === cur.name) && acc.push(cur);
							return acc;
						}, []);
					}
				}
			},
			//删除作者
			deleteAutor(item){
				this.autors.splice(this.autors.indexOf(item),1);
			},
			//删除著作人
			deleteObligee(item){
				this.obligees.splice(this.obligees.indexOf(item),1);
			},

			//查看声明样例
			showDeclareSample(){
				this.declareSrc = this.form.copyrightType;
				this.isShowDeclare = true ;
			},

			//提交/重新提交
			addcert(){
				// $("#addcertButton").attr("disabled","disabled");
        var isChecked = document.getElementById("protocalCheck").checked;
        if(!isChecked){
          toast('请确认《申请版权预登记及作品登记须知》已阅读并同意')
          return false ;
        }
				let _this = this;
        _this.isDisabled = true;
				let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
				if(userInfo.length == 0){
					toast('请登录后再操作',function(){
						_this.$router.push({
							path:'/'
						})
					})
					return false;
				}
        if(_this.form.powerBy == null || _this.form.powerBy == ''){
          _this.isDisabled = false;
          toast('请选择权利取得方式')
          return false ;
        }

        if(_this.autors.length > 5 || _this.obligees.length > 5){
          _this.isDisabled = false;
          toast('作者和著作权人最多支持5个')
          return false ;
        }
				/**
				 * 判断作者和著作人
				 * 1 判断是否为空
				 * 2 如果是合作作品 ，则作者和著作权人都必须大于等于2
				 */
				console.log("_this.autors",_this.autors);
				if(_this.autors.length<=0 || _this.obligees.length <=0){
          _this.isDisabled = false;
					toast("请选择作者和著作人");
					return false ;
				}else if(_this.form.copyrightType == "2" && (_this.autors.length<2)){
          _this.isDisabled = false;
					toast("合作作品，作者必须大于等于2个");
					return false ;
				}
				else{
					let aid = "";
					let oid = "";
					_this.autors.forEach(item=>{
						aid += item.id + ",";
					})
					_this.obligees.forEach(item=>{
						oid += item.id + ",";
					})
					_this.form.authorIds = aid.substr(0,aid.length-1);
					_this.form.powerUserIds = oid.substr(0,oid.length-1);
				}

				//判断作品名称
				if(_this.form.workFullName == null || _this.form.workFullName == "" || _this.form.workFullName.trim() == ""){
          _this.isDisabled = false;
					toast("请填写作品名称")
					return false ;
				}

				//判断作品文件
				if(_this.worksList.length <=0){
          _this.isDisabled = false;
					toast("请填选择作品文件")
					return false ;
				}else{
					let chanShowList = _this.worksList ;
					let urls='';
					for(let i=0;i<chanShowList.length;i++){
						urls += i==chanShowList.length-1?chanShowList[i].attachmentUrl:chanShowList[i].attachmentUrl+',';
					}
					if(_this.urls==''){
            _this.isDisabled = false;
						toast('请选择要上传的作品文件')
						return false;
					}else{
						_this.form.workUrl = urls ;
					}
				}

				//判断作品创作性质
				if(_this.form.creativeType=="")
				{
          _this.isDisabled = false;
					toast("请选择作品创作性质")
					return false ;
				}else{
					_this.form.creativeType = _this.form.creativeType[0];
				}

				//判断 作品创作类型
				if(_this.form.workType == ""){
          _this.isDisabled = false;
					toast("请选择作品类型")
					return false ;
				}else{
					_this.form.workType = _this.form.workType;
				}


				// 创作完成时间
				if(!_this.form.completeDateEnd){
          _this.isDisabled = false;
					toast("请选择创作完成时间")
					return false ;
				}else{
					let dt  = new Date(_this.form.completeDateEnd);
					let year = dt.getFullYear();
					let month = (dt.getMonth() + 1) >= 10 ? (dt.getMonth() + 1) : "0" + (dt.getMonth() + 1);
					let date = dt.getDate() <10? "0" + dt.getDate() : dt.getDate() ;
					_this.form.completeDateEnd =  year+ "-" + month + "-" + date;
				}

				//debugger ;
				//作品完成地点
				console.log("作品完成地点：：：",_this.placeOfCompletion);
				if(!_this.placeOfCompletion || _this.placeOfCompletion == "")
				{
          _this.isDisabled = false;
					toast("请选择作品完成地点")
					return false ;
				}else{
					_this.form.completeCountry =  _this.placeOfCompletion[0];
					_this.form.completeProvince = _this.placeOfCompletion[1];
					_this.form.completeCity = _this.placeOfCompletion[2];
				}
				console.log(_this.form.publishStatus)
				if(!_this.form.publishStatus || _this.form.publishStatus == ''){
          _this.isDisabled = false;
					toast("请选择作品发表状态")
					return  false

				}
        console.log('_this.form.publishStatus================:' + _this.form.publishStatus)
				// _this.form.publishStatus = _this.form.publishStatus[0];
				//发表状态 如果时已发表，则判断发表时候的地点和时间
				if(_this.form.publishStatus == '1') {
					//发表完成时间
					if(!_this.form.publishDate){
            _this.isDisabled = false;
						toast("请选择作品首次发表时间")
						return false ;
					}else{
						let dt  = new Date(_this.form.publishDate);
						let year = dt.getFullYear();
						let month = (dt.getMonth() + 1) >= 10 ? (dt.getMonth() + 1) : "0" + (dt.getMonth() + 1);
						let date = dt.getDate() <10? "0" + dt.getDate() : dt.getDate() ;
						_this.form.publishDate =  year + "-" + month + "-" + date;
            dt = new Date(_this.form.publishDate);

            let publishDateMilli = dt.getTime();
            let completeDateEndDt  = new Date(_this.form.completeDateEnd);
            let completeDateEndMilli = completeDateEndDt.getTime();

            if(completeDateEndMilli > publishDateMilli){
              _this.isDisabled = false;
              toast("作品首次发表时间不能早于创作完成时间")
              return false ;
            }
					}
					//发表完成地点
					console.log("作品发表地点：：：",_this.placeOfPublication);
					if(!_this.placeOfPublication || _this.placeOfPublication== "")
					{
            _this.isDisabled = false;
						toast("请选择作品首次发表地点")
						return false ;
					}else{
						_this.form.publishCountry =_this.placeOfPublication[0];
						_this.form.publishProvince = _this.placeOfPublication[1];
						_this.form.publishCity = _this.placeOfPublication[2];
					}

          if (_this.publishUrlList.length > 0) {
            let chanShowList = _this.publishUrlList;
            let urls = '';
            for (let i = 0; i < chanShowList.length; i++) {
              if (chanShowList[i].status && chanShowList[i].status == 'uploading') {
                _this.isDisabled = false;
                toast('请上传完成后，再提交');
                return false
              }
              urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
            }
            _this.form.publishUrl = urls;
          }
				} else{
					_this.form.publishDate='';
					_this.placeOfPublication = [];
					_this.form.publishCountry ='';
					_this.form.publishProvince = '';
					_this.form.publishCity = '';
					_this.form.publishUrl = '';

				}

        if(_this.form.publishStatus == '1'){
          if (_this.publishUrlList.length == 0){
            _this.isDisabled = false;
            toast('请上传已发表的截图或照片');
            return false
          }else if(_this.publishUrlList.length > 1){
            _this.isDisabled = false;
            toast('已发表的截图或照片附件仅支持提交一个');
            return false
          }
        }


				// 附件 也可以为空
				if(_this.enclosureList.length > 0){
					let chanShowList = _this.enclosureList ;
					let urls='';
					for(let i=0;i<chanShowList.length;i++){
						urls += i==chanShowList.length-1?chanShowList[i].attachmentUrl:chanShowList[i].attachmentUrl+',';
					}
					_this.form.otherAttachments = urls ;
				}/*else{
          _this.isDisabled = false;
          toast('请在附件处上传作品权利保证书');
          return false
        }*/

        //作品展示图
        if (_this.productImageUploadFileList.length > 0) {
          let chanShowList = _this.productImageUploadFileList;
          let urls = '';
          for (let i = 0; i < chanShowList.length; i++) {
            if (chanShowList[i].status && chanShowList[i].status == 'uploading') {
              _this.isDisabled = false;
              toast('作品展示图上传完成后再提交');
              return false
            }
            urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
          }
          _this.form.productImageAttachments = urls;
        }

        //权利保证书
        if (_this.autGuarAnnexUploadFileList.length > 0) {
          let chanShowList = _this.autGuarAnnexUploadFileList;
          let urls = '';
          for (let i = 0; i < chanShowList.length; i++) {
            if (chanShowList[i].status && chanShowList[i].status == 'uploading') {
              _this.isDisabled = false;
              toast('权利保证书上传完成后再提交');
              return false
            }
            urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
          }
          _this.form.autGuarAnnexAttachments = urls;
        } else {
          _this.isDisabled = false;
          toast('请上传权利保证书');
          return false
        }
        const intention = _this.form.createIntention?_this.form.createIntention.trim():'';
        if (intention.length < 10) {
          _this.isDisabled = false;
          toast('创作意图最少10个字符');
          return false
        }

				//创作声明的判断
				if(_this.form.copyrightType =="2"||_this.form.copyrightType =="4"||_this.form.copyrightType =="5"){
					if(_this.statementList.length<=0){
            _this.isDisabled = false;
						toast("请选择创作声明")
						return false ;
					}else{
						let chanShowList = _this.statementList ;
						let urls='';
						for(let i=0;i<chanShowList.length;i++){
              if(chanShowList[i].attachmentUrl == undefined){
                _this.isDisabled = false;
                toast("部分作品文件未上传成功，请重新上传")
                return false ;
              }
							urls += i==chanShowList.length-1?chanShowList[i].attachmentUrl:chanShowList[i].attachmentUrl+',';
						}
						if(_this.urls==''){
              _this.isDisabled = false;
							toast('请选择要上传的作品文件')
							return false;
						}else{
							_this.form.workInstruction = urls ;
						}
					}
				}

				//权益拥有情况
				let isHaveSelect=false;
				let powerScopeType = "";
				_this.Ownership.forEach(item=>{
					if(item.checked==true)
					{
						isHaveSelect = true ;
						powerScopeType += item.value + ","
					}
				});
				if(isHaveSelect==false)
				{
          _this.isDisabled = false;
					toast('请选择权利拥有情况')
					return false ;
				}
				console.log("powerScopeType :: ",powerScopeType);
				_this.form.powerScope = powerScopeType.substr(0,powerScopeType.length-1);

				//独创性和创作意图可以为空
				// 提交

				//debugger ;
				_this.form.preRechargeFlag = _this.isPreRechargeFlag;
				console.log("登记的传参  :: ",_this.form);
				if(_this.isReset==true){
					_this.form.orderSeqNo = _this.copyrightDetailsId ;
					_this.form.powerBy = "1";
					_this.isDisabled = true;
					_resubmit(_this.form).then(res=>{
						this.resultJ(res);
					});

				}else{
					_this.isDisabled = true;
					_save(_this.form).then(res=>{
						this.resultJ(res);
					});
				};
			},
			resultJ(res){
				console.log("登记提交后的返回结果：：：",res);
				console.log('提交成功后的回调',res)

        let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):"";
				if(res.code==200){
          this.form = '';
					toast('登记保存成功')
					this.$router.push({ path:'/myDci' })
				}else if(res.code==213){
          this.isDisabled = false;
					toast("请实名认证后使用功能")
					this.$router.push('/authentication')
				}else if(res.code==214){
          this.isDisabled = false;
					toast("请购买产品后使用")
					if(userInfo.accountType=="person"){
						this.$router.push('/goods')
					}else{
						this.$router.push('/goods')
					}
				}else if(res.code==216){
					// this.monitorBagState = true;
					// $("#addcertButton").removeAttr("disabled");
          this.isDisabled = false;
          toast("剩余次数不足，请购买加油包或产品")
				}else if(res.code==215){
					toast("请购买产品后使用")
					this.myczPayState = true;
					// $("#addcertButton").removeAttr("disabled");
					this.isDisabled = false;
				}else{
					toast(res.message)
					// $("#addcertButton").removeAttr("disabled");
					this.isDisabled = false;
				}

			},
			//上传作品文件
			showmessagefromchild(data){
				let _this = this;
				for(let i = 0;i < data.length;i++){
          if (data[i].status && data[i].status == 'uploading') {
            break
          }

					let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.')+1)
          layout = layout.toLowerCase();
					if(reImg.test(layout)){
						// if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
						// 	data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
						// }
						data[i].url = util.thumbnail(data[i].url )
					}else if(reMusic.test(layout)){
						data[i].url = _this.music;
					}else if(reText.test(layout)){
						data[i].url = _this.text;
					}else if(reVideo.test(layout)){
						data[i].url = _this.video;
					}else{
						data[i].url = _this.other;
					}
				}
				_this.worksList = data
        this.$forceUpdate()
			},

      //上传作品展示图
      showmessagefromchild4(data) {
        let _this = this;
        for (let i = 0; i < data.length; i++) {
          if (data[i].status && data[i].status == 'uploading') {
            break
          }

          let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
          if (reImg.test(layout)) {
            data[i].url = util.thumbnail(data[i].url);
          } else if (reMusic.test(layout)) {
            data[i].url = _this.music;
          } else if (reText.test(layout)) {
            data[i].url = _this.text;
          } else if (reVideo.test(layout)) {
            data[i].url = _this.video;
          } else {
            data[i].url = _this.other;
          }
        }
        console.log(data)
        _this.productImageUploadFileList = data
        this.$forceUpdate()
      },

      //上传权利保证书
      showmessagefromchild5(data) {
        let _this = this;
        for (let i = 0; i < data.length; i++) {
          if (data[i].status && data[i].status == 'uploading') {
            break
          }

          let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
          if (reImg.test(layout)) {
            data[i].url = util.thumbnail(data[i].url);
          } else if (reMusic.test(layout)) {
            data[i].url = _this.music;
          } else if (reText.test(layout)) {
            data[i].url = _this.text;
          } else if (reVideo.test(layout)) {
            data[i].url = _this.video;
          } else {
            data[i].url = _this.other;
          }
        }
        console.log(data)
        _this.autGuarAnnexUploadFileList = data
        this.$forceUpdate()
      },

			//删除作品文件
			deleteList(item){
        if(this.isReset && this.reSubmitDisabled) {
          toastNewline('请谨慎修改作品文件！\n' +
              '作品文件任何变动均视为新订单，出证日期将重新计算！')
          this.reSubmitDisabled = false;
        }
				// //debugger ;
				this.worksList.splice(this.worksList.indexOf(item),1);
			},
			//上传附件
			showmessagefromchild1(data){
				let _this = this;
				for(let i = 0;i < data.length;i++){
          if (data[i].status && data[i].status == 'uploading') {
            break
          }

					let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.')+1)
          layout = layout.toLowerCase();
					if(reImg.test(layout)){
						// if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
						// 	data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
						// }
						data[i].url = util.thumbnail(data[i].url )
					}else if(reMusic.test(layout)){
						data[i].url = _this.music;
					}else if(reText.test(layout)){
						data[i].url = _this.text;
					}else if(reVideo.test(layout)){
						data[i].url = _this.video;
					}else{
						data[i].url = _this.other;
					}
				}
				_this.enclosureList = data
        this.$forceUpdate()
			},
			//删除附件
			deleteList_fj(item){
				this.enclosureList.splice(this.enclosureList.indexOf(item),1);
			},

      //删除作品展示图
      deleteList_zst(item){
        this.productImageUploadFileList.splice(this.productImageUploadFileList.indexOf(item),1);
      },
      //删除权利保证书
      deleteList_bzs(item) {
        this.autGuarAnnexUploadFileList.splice(this.autGuarAnnexUploadFileList.indexOf(item), 1);
      },

      //上传附件
      showmessagefromchild3(data){
        let _this = this;
        for(let i = 0;i < data.length;i++){
          if (data[0].status && data[0].status == 'uploading') {
            break
          }
          let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.')+1)
          layout = layout.toLowerCase();
          if(reImg.test(layout)){
            // if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
            // 	data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
            // }
            data[i].url = util.thumbnail(data[i].url )
          }else if(reMusic.test(layout)){
            data[i].url = _this.music;
          }else if(reText.test(layout)){
            data[i].url = _this.text;
          }else if(reVideo.test(layout)){
            data[i].url = _this.video;
          }else{
            data[i].url = _this.other;
          }
        }
        _this.publishUrlList = data
        this.$forceUpdate()
      },
      //删除附件
      deleteList_fj2(item){
        this.publishUrlList.splice(this.publishUrlList.indexOf(item),1);
      },

			//创作声明，只有一个文件
			showmessagefromchild2(data){
				let _this = this;
        if (data[0].status && data[0].status == 'uploading') {
          return
        }
				let layout = data[0].attachmentUrl.substring(data[0].attachmentUrl.lastIndexOf('.')+1)
        layout = layout.toLowerCase();
				if(reImg.test(layout)){
					// if(data[0].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
					// 	data[0].url = data[0].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
					// }
					data[0].url = util.thumbnail(data[0].url);
				}else{
					data[0].url = _this.other;
				}


				_this.declare_upload_success=true;
				_this.declare_file_name=_this.declare_file_names[_this.form.copyrightType] + "." + layout;

				console.log('获取接口后的存证数据',data)
				_this.statementList = data
			},
			//权益拥有情况 全
			selectAll(value){
        const forbidIds = ['1','2','3','4'];
        this.Ownership.forEach(item=>{
          // 如果是继承状态，4项人身权强制不修改
          if (!(this.form.powerBy === '2' && forbidIds.includes(item.value))) {
            item.checked = value;
          }
        });
			}
		}
	}
</script>

<style scoped lang="less">
#copyrightRegistration {
  width: 100%;
  background: #F1F4F8;
}

.copyrightRegistration {
  width: 1334px;
  min-height: 2000px;
  background: #FFFFFF;
  box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
  border-radius: 4px;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  /deep/ .ivu-radio {
    line-height: revert;
  }

  /deep/ .ivu-radio-focus {
    box-shadow: none;
  }

  .row_item {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .row_item_1 {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .col_label {
    width: 140px;

    p {
      width: 140px;
      text-align: right;
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
    }
  }

  .col_value {
    margin-left: 60px;
    display: flex;
    align-items: center;
  }

  .top20 {
    margin-top: 20px;
  }

  .selectWidth {
    width: 320px;
    height: 38px;
  }

  .radio_group .radio_item_name {
    font-size: 14px;
    color: #666666;
    margin-left: -18px;
    padding-top: 3px;
  }

  .monitor_type .radio_item {
    margin-right: 40px;
  }

  .radio_item.ivu-radio-wrapper-checked .radio_item_name {
    color: #666666;
  }

  /deep/ .radio_item .ivu-radio {
    margin-right: 10px;
  }

  /deep/ .radio_item .ivu-radio-inner {
    width: 12px;
    height: 12px;
    border-radius: 0;
    /*border: 1px solid #B5B5B5;*/
  }

  /deep/ .radio_item .ivu-radio-inner {
    width: 12px;
    height: 12px;
    /*background: url(../../../assets/common/unChecked.png) no-repeat;*/
    border-color: #b5b5b5;
    background-size: cover;
  }

  .radio_item .ivu-radio-checked .ivu-radio-inner {
    border-color: #FFD800;
  }

  /deep/ .radio_item .ivu-radio-inner:after {
    width: 12px;
    height: 12px;
    left: -1px;
    top: -1px;
    /*background: url(../../../assets/common/new_lo_ye.png) no-repeat;*/
    background-color: #ffd800;
    /*background-size: cover;*/
  }

  /deep/ .radio_item .ivu-radio-inner:after {
    width: 12px;
    height: 12px;
    left: -1px;
    top: -1px;
    border-radius: 0;
    background-color: #ffd800;
  }

  /deep/ .ivu-select-single .ivu-select-selection {
    height: 38px;
  }

  /deep/ .ivu-select-selection:hover {
    /*border: 1px solid #ffd800;*/
    border-color: #ffd800;
  }

  /deep/ .ivu-select-selection-focused {
    border-color: #ffd800;
  }

  /deep/ .ivu-select-visible .ivu-select-selection {
    border-color: #ffd800;
    box-shadow: none;
  }

  /deep/ .ivu-input:hover {
    border-color: #ffd800;
  }

  /deep/ .ivu-date-picker-focused input {
    box-shadow: none;
    border-color: #ffd800;
  }

  /deep/ .el-cascader:not(.is-disabled):hover .el-input__inner {
    border-color: #ffd800;
  }

  /deep/ .el-cascader .el-input .el-input__inner:focus {
    border-color: #ffd800;
  }

  /deep/ .el-cascader .el-input.is-focus .el-input__inner {
    border-color: #ffd800;
  }

  /deep/ .row_item .ivu-select-selection .ivu-select-selected-value {
    height: 38px;
    line-height: 38px;
  }

  /deep/ .row_item .ivu-select-selection .ivu-select-placeholder {
    height: 38px;
    line-height: 38px;
    color: #999999;
  }
}

.cw_ul_type{
	display:flex;
	justify-content: flex-start;
	margin-top:30px;
	.cw_li_tb{
		margin-right: 20px;
		width: 212px;
		height: 264px;
		background: #ffffff;
		border-radius: 4px;
		border: 1px solid #b9b9b9;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		img{
			margin:20px 0px 20px 20px;
		}
		div{
			height:20px;
			font-size:14px;
			font-weight:400;
			color:rgba(51,51,51,1);
			line-height:20px;
			margin-bottom:10px;
			margin-left:20px;
		}
		p{
			width:172px;
			font-size:12px;
			font-weight:400;
			color:rgba(102,102,102,1);
			line-height:17px;
			margin:0 auto;
		}
	}
}
	.toRegDetail{
		padding-top: 20px;
		background-color: rgba(241,244,248,1);
		.main{
			width: 1334px;
			margin: 0 auto;
			.title{
				width: 100%;
				height: 63px;
				padding-left: 25px;
				font-size: 20px;
				color: #333;
				line-height: 63px;
				background-color: #fff;
				border-radius: 2px 2px 0 0;
				box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
			}
			.tabTit{
				width: 100%;
				height: 68px;
				background-color: #fff;
				box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
				padding-left: 42px;
				.tit{
					font-size: 14px;
					color: #666;
					line-height: 68px;
					margin-right: 50px;
					float: left;
				}
				.ivu-radio-group{
					font-size: 20px;
					color: #999;
					line-height: 68px;
				}
				.radio_group .radio_item_name {
					margin-left: 4px;
					font-size: 14px;
					color: #999;
					margin-right: 72px;
					transition:none;
					transform: none;
				}

			}
			/*作者*/
			.item_wrap{
				.item{
					width: 100%;
					height: 80px;
					background-color: #fff;
					//border: 1px solid rgba(238,238,238,1);
					border-left: none;
					border-right: none;
					.tit{
						width: 100px;
						height: 80px;
						line-height: 80px;
						float: left;
						margin-left: 40px;
						margin-right: 24px;
						font-size: 14px;
						color: #666;
						text-align: left;
					}
					.content_wrap{
						width: 1170px;
						height: 80px;
						float: left;
						padding-top: 22px;
						.btn_wrap{
							float: left;
							.btn{
								width: 120px;
								height: 38px;
								background-color: #121210;
								color: #fff;
								line-height: 38px;
								text-align: center;
								border-radius: 2px;
								cursor: pointer;
							}
						}
					}
				}

				.works_file{
					height: 390px;
					.item{
						height: 390px;
					}
					.content_wrap{
						padding-top: 25px;
					}

				}
				.works_state{
					width: 100%;
					height: 80px;
					background-color: #fff;
					.item{
						width: 540px;
						float: left;
						.content_wrap{
							width: 376px;
						}
					}
				}
				.works_declare{
					width: 100%;
					height: 188px;
					.item{
						height:188px;
					}
 					/*合作声明*/
					.creatInfo-span{
						margin-left: 30px;
						margin-right: 10px;
						margin-top:10px;
						width:56px;
						font-size:14px;
						font-weight:400;
						color:rgba(18,18,16,1);
						text-decoration: underline;
					}
					.declare_sample{
						margin-left: 10px;
						margin-top:10px;
						font-size:14px;
						font-weight:400;
						color:rgba(51,51,51,1);
						cursor: pointer;
					}
				}
				.works_possess{
					height: 170px;
					.item{
						height: 170px;
					}
					.content_wrap{
            margin-top: 12px;
            margin-bottom: 26px;
						width: 800px;
						.owner_checkbox{
							width: 690px;
							display: flex;
							flex-direction: row;
							flex-wrap: wrap;
							margin-top: 10px;
							p{
								margin-right: 40px;
								margin-bottom: 5px;
								input{
									margin-right: 10px;
								}
							}
						}
					}
				}
				.works_intention{
					height: 168px;
					.item{
						height: 168px;
						textarea{
							width: 760px;
							height: 100px;
							padding: 15px;
							resize: none;
						}
					}
				}
				.works_create{
					height: 168px;
					.item{
						height: 168px;
						textarea{
							width: 760px;
							height: 100px;
							padding: 15px;
							resize: none;
						}
					}
				}
			}
		}
		/*提交按钮*/
		.sub{
			width: 100%;
			height: 126px;
			padding-top: 30px;
			.btn{
				width: 124px;
				height: 42px;
				background-color: #121210;
				color: #fff;
				font-size: 14px;
				text-align: center;
				line-height: 42px;
				margin: 0 auto;
				cursor: pointer;
			}
		}
	}


	.certList_right{
		display:flex;
		flex-direction: column;
		.certList_right_top{
			height:194px;
			display:flex;
			justify-content: flex-start;
			.showtextDf{
				margin-left:20px;
				div{
					height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(153,153,153,1);
					line-height:20px;
					margin-top:64px;
					margin-bottom:10px;
				}
				p{
					font-size:14px;
					font-weight:400;
					color:rgba(153,153,153,1);
					line-height:20px;
				}
			}
		}
	}


	.show_Picture{
		margin-right:20px;
		div{
			width:103px;
			height:17px;
			font-size:12px;
			font-weight:400;
			color:rgba(102,102,102,1);
			line-height:17px;
			overflow: hidden;
			text-overflow:ellipsis;
			white-space: nowrap;
			margin-top:5px;
		}
		.showSc{
			position:relative;
			height:70px;
			width: 103px;
			cursor:pointer;
			&:hover{
				width:103px;
				height:70px;
				.showDelete{
					display:block;
				}
			}
			.showDelete{
				width:103px;
				height:70px;
				background: rgba(0,0,0,0.3);
				display:none;
				position:absolute;
				left:0;
				right:0;
				top:0;
				bottom:0;
				margin:auto;
				text-align: center;
				overflow: hidden;
			}
			.showshanchu{
				width:18px;
				height:18px;
				margin-top:26px;
			}
		}
	}

	.show_autor_Picture{
		margin-right:20px;
		div{
			min-width:103px;
			height:17px;
			font-size:12px;
			font-weight:400;
			color:rgba(102,102,102,1);
			line-height:17px;
			overflow: hidden;
			text-overflow:ellipsis;
			white-space: nowrap;
			margin-top:5px;
		}
		.showSc_autor{
			position:relative;
			min-width:108px;
			height:38px;
			cursor:pointer;
			margin-top: 0px;
			margin-right:5px;
			&:hover{
				min-width:108px;
				height:38px;
				.showshanchu{
					display:block;
				}
			}
			.showshanchu{
				width:14px;
				height:14px;
				position: absolute;
				top: 6px;
				right: 3px;
				display: none;
				/*margin-top:26px;*/
			}
		}
	}

	.publish_status{
		.pulish_status_span{
			margin-left:20px;
			margin-right: 15px;
		}
	}

	.autors_class{
		/*width:108px;*/
		min-width:108px;
		height:38px;
		background:rgba(18,18,16,1);
		border-radius:4px;
		font-size:16px;
		font-weight:400;
		border:none ;
		color:rgba(255,255,255,1);
		line-height:24px;
		padding: 0 8px;
	}

</style>
<style type="text/css">
  .disabled {
    pointer-events: none;
  }
	.ivu-checkbox-wrapper-checked{
		color: #333;
	}
	.ivu-checkbox-indeterminate .ivu-checkbox-inner{
		background-color: #fff !important;
		border-color: #333 !important;
	}
	.ivu-checkbox-checked .ivu-checkbox-inner{
		background-color: #fff !important;
		border-color: #333 !important;
	}
	.ivu-checkbox-indeterminate .ivu-checkbox-inner:after{
		border-color: #333;
	}
	.ivu-checkbox-checked .ivu-checkbox-inner:after{
		border-color: #333;
	}
	.ivu-radio-checked .ivu-radio-inner{
		border-color: #333;
		transition:none;
		transform: none;
	}
	.ivu-radio-inner:after{
		left: 2.5px;
		background-color:#333
	}
	.ivu-radio-checked:hover .ivu-radio-inner{
		border-color: #333;
	}
	/deep/ .radio_item.ivu-radio-wrapper-checked .radio_item_name {
		color: #333;
		transition:none !important;
		transform: none;
	}
	.ivu-radio-focus{
		box-shadow: none;
	}
	.ivu-checkbox-focus{
		box-shadow: none;
	}
	.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
		height: 48px;
	}
	/*.ivu-input{*/
	/*	height: 40px !important;*/
	/*}*/

	.ivu-input{
		border: 1px solid #E5E7EA;
		border-radius: 0px;
		box-shadow: none;
		height: 40px;
		font-size:14px;
		font-weight:400;
		color:rgba(153,153,153,1);
		line-height:21px;
	}
	.ivu-input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
		color: #868686;
	}
	.ivu-input::-moz-placeholder { /* Firefox 19+ */
		color: #868686;
	}
	.ivu-input:-ms-input-placeholder { /* IE 10+ */
		color: #868686;
	}
	.ivu-input:-moz-placeholder { /* Firefox 18- */
		color: #868686;
	}
	.ivu-input:hover{
		border-color:#121210;
	}
	.ivu-input:focus{
		border-color:#121210;
		outline: 0;
	}
	.el-textarea__inner:focus {
		outline: 0;
		border-color: #121210;
	}
	.el-input.is-active .el-input__inner, .el-input__inner:focus{
		outline: 0;
		border-color: #121210;
	}

	.ivu-input-prefix i, .ivu-input-suffix i{
		line-height: 38px;
	}

  input[type=checkbox]:disabled {
    cursor: not-allowed;
  }
  /* 禁用且已勾选：把对勾改成浅灰色、背景变浅灰，弱化选中效果 */
  input[type=checkbox]:disabled:checked:after {
    color: #cccccc !important;
  }
  input[type=checkbox]:disabled:before {
    background-color: #f0f0f0 !important;
    border-color: #cccccc !important;
  }



	input[type=checkbox] {
		width: 14px;
		height: 14px;
		-webkit-appearance: none;
		background-color: transparent;
		border: 0;
		outline: 0 !important;
		color: #d8d8d8;
		position: relative;
	}
	input[type=checkbox]:before{
		content: "";
		display:block;
		width: 14px;
		height: 14px;
		border: 1px solid #ddd;
		background-color: #fff;
		box-sizing:border-box;
		position: absolute;
	}

	input[type=checkbox]:disabled:before{
		content: "";
		display:block;
		width: 14px;
		height: 14px;
		border: 1px solid #333;
		box-sizing:border-box;
		border-radius: 0;
		position: absolute;
	}
	input[type=checkbox]:checked:before{
		content: "";
		display:block;
		width: 14px;
		height: 14px;
		border: 1px solid rgba(18,18,16,1);
		box-sizing:border-box;
		position: absolute;
	}
	input[type=checkbox]:checked:after{
		content: "\2714";
		display:block;
		width:  10px;
		height: 10px;
		color: #333;
		position: absolute;
		transform: rotate(10deg) translate(18%, -45%);
	}

	.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{
		border-color: #121210;
	}

  .atlas_group{
    display:flex;
    justify-content:flex-start;
    flex-wrap: wrap;
  }

</style>


<style lang="less" scoped>
  .upload_progress {
    color: #F7B500 !important;
    font-size: 14px;
    text-align: center;
    border: 1px solid #F7B500;
    flex-direction: column;
    display: flex;
    justify-content: center;
    border-radius: 4px;
    cursor: default;


    .upload_progress_desc {
      font-size: 24px;
      font-weight: 500;
      line-height: 33px;
    }

    .upload_progress_shadow {
      position: absolute;
      width: 100%;
      bottom: 0;
      background: rgba(255, 216, 0, 0.3);
      border-radius: 4px;
      transition: all .5s;
    }

  }

  .upload_progress_one {
    width: 138px;
    height: 38px;
    border: 1px solid #F7B500;
    border-radius: 4px;
    margin: 0 2px 8px 0;
    font-size: 14px;
    text-align: center;
    line-height: 38px;
    color: #F7B500;
    position: relative;

    .upload_progress_one_shadow {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background: rgba(255, 216, 0, 0.3);
      border-radius: 4px;
      transition: all .5s;
    }
  }

  .copyrightRegistration .show_Picture .showSc.upload_progress {
    cursor: default;
  }

  .declare_upload_success_name {
    display: inline-block;
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 20px;

  }

  .red-border-input {
    margin-left: 111px;
  }

</style>
